import React, { Component } from "react";
import PropTypes from "prop-types";
import debounce from "lodash.debounce";
import { filterList } from "../../../utils/sorting";

class FilterListRenderProps extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    filterKey: PropTypes.string.isRequired,
  };

  static defaultProps = {
    onChange: undefined,
  };

  constructor(props) {
    super(props);
    this.state = {
      searchString: "",
      filteredData: props.data,
    };

    this.handleSearchChange = debounce(this.updateFilteredData, 300).bind(this);
    this.inputRef = React.createRef();
  }

  componentDidUpdate(prevProps, { searchString }) {
    if (searchString !== this.state.searchString) {
      this.handleSearchChange(this.state.searchString);
    }
  }

  clearInput() {
    this.inputRef.current.value = "";
  }

  handleChange = ({ target }) => {
    const { value } = target;
    if (value !== this.state.searchString) {
      this.setState({
        searchString: `${value}`,
      });
    }
  };

  updateFilteredData(searchString) {
    const filteredData = filterList(
      searchString,
      this.props.filterKey,
      this.props.data
    );

    this.setState(
      {
        searchString,
        filteredData,
      },
      () => {
        const { onChange } = this.props;
        if (typeof onChange === "function") {
          onChange(this.state);
        }
      }
    );
  }

  render() {
    return this.props.children({
      onChange: this.handleChange,
      searchString: this.state.searchString,
      rawData: this.props.data,
      rawLength: this.props.data.length,
      data: this.state.filteredData,
      dataLength: this.state.filteredData.length,
      inputRef: this.inputRef,
    });
  }
}

export default FilterListRenderProps;
